import { dataTransferWrap } from '../dataTransferService'

import dtConfig from '@/config/data-transfer'
import { ModulesMap } from '@/config/data/modulesMaps'

function getDoneFieldWorks(companyId, query) {
  return dataTransferWrap(
    ModulesMap.DONE_WORKS_DONE_FIELD_WORKS,
    dtConfig[ModulesMap.DONE_WORKS_DONE_FIELD_WORKS].getDoneFieldWorks,
    {
      urlParams: {
        companyId,
      },
      params: query,
    },
  )
}

export default {
  getDoneFieldWorks,
}